function main() {
    let groupCells;
    if (window.innerWidth < 768) {
        groupCells = 1;
    } else {
        groupCells = 3;
    }

    $('.homepage-latest-carousel').flickity({
        accessibility: true,
        cellAlign: 'left',
        cellSelector: '.homepage-latest-carousel__cell',
        contain: true,
        groupCells: groupCells,
        imagesLoaded: true,
        pageDots: true,
        prevNextButtons: true,
        arrowShape: {
            x0: 20,
            x1: 65, y1: 40,
            x2: 65, y2: 15,
            x3: 65
        }
    });
}

export default function () {
    main();
}
